import { IUser } from "Auth/types";
import { API_ENDPOINTS, API_ERROR_CODES } from "shared/constants";
import { APIService } from "shared/services";
import { IAPIError, IDataKeys, IJSONAPIItem } from "shared/types";

export interface IJSONAPIApiKey {
  id: string;
  type: string;
  attributes: {
    id: string;
    name: string;
    keyPrefix: string;
    createdAt: string;
    user: IUser;
    apiKey?: string;
  };
}

export interface IJSONAPIApiKeysCollection {
  [IDataKeys.userApiKey]: IJSONAPIApiKey;
  meta: {
    [key: string]: IJSONAPIItem;
  };
  pagination: any;
}

export class UserApiKeyService {
  static createUserApiKey = (description: string): Promise<IJSONAPIApiKey> =>
    new Promise(async (resolve, reject) => {
      try {
        const response: IJSONAPIApiKeysCollection = await APIService.post({
          path: API_ENDPOINTS.USER_API_KEY,
          data: {
            name: description,
          },
        });

        const key = Object.values(response[IDataKeys.userApiKey])[0];

        resolve(key as IJSONAPIApiKey);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(
          API_ERROR_CODES.POST_USER_API_KEY
        );
        reject({ error });
      }
    });

  static getUserApiKey = (): Promise<IJSONAPIApiKey["attributes"][]> =>
    new Promise(async (resolve, reject) => {
      try {
        const response: IJSONAPIApiKeysCollection = await APIService.get({
          path: API_ENDPOINTS.USER_API_KEY,
        });

        if (response[IDataKeys.userApiKey] === undefined) {
          resolve([]);
        }

        const keys = Object.values(
          response["userApiKey"] as IJSONAPIApiKey
        ).map((key) => key.attributes);

        resolve(keys);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.GET_USER_API_KEY);
        reject({ error });
      }
    });

  static deleteUserApiKey = (id: string): Promise<any> =>
    new Promise(async (resolve, reject) => {
      try {
        const response: unknown = await APIService.delete({
          path: API_ENDPOINTS.USER_API_KEY_DELETE(id),
        });
        resolve(response as any);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(
          API_ERROR_CODES.DELETE_USER_API_KEY
        );
        reject({ error });
      }
    });

  static deleteUserApiKeys = (ids: string[]): Promise<any> =>
    new Promise(async (resolve, reject) => {
      try {
        const promises = ids.map((id) =>
          APIService.delete({
            path: API_ENDPOINTS.USER_API_KEY_DELETE(id),
          })
        );

        await Promise.all(promises);
        resolve(true);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(
          API_ERROR_CODES.DELETE_USER_API_KEY
        );
        reject({ error });
      }
    });
}
